<template>
  <section class="section_dethi">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li><router-link :to="{name: 'ebook'}">Sách điện tử</router-link></li>
          <li>
            <router-link v-for="(item, index) in ebooks" :key="index" v-if="index==0" :to="{ name: 'ebook-group', params: {id: item.bookTypeId} }" title="">
              {{item.name}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>    
    <div class="ss-data">
      <div class="container-hts">
        <b-tabs class="book-detail__tabs" v-for="(item, index) in ebooks" :key="index" v-if="index==0">
            <b-tab class="book-detail__tab" v-for="(groupItem, index3) in item.bookGroups">
              <template v-slot:title>{{groupItem.name}}</template>
                  <div class="ss-data list__box__body list__box__body--grid">
                    <div class="box_content">
                      <div class="row">
                        <div class="item col-xl-3 col-lg-4 col-md-4 col-sm-6" v-for="(itemBook, index2) in groupItem.books">
                          <div class="item__wrap position-rel text-center">
                            <div class="item__head">
                              <router-link :to="{ name: 'ebook-detail', params: { id: itemBook.bookId, slug: itemBook.slug } }">
                                <img class="inner-img" :src="itemBook.imageUrl!=null?cdnUrl +itemBook.imageUrl.replace('Content//images','images'):''" :alt="itemBook.name" />
                              </router-link>
                            </div>
                            <div class="item__body">
                              <h3 class="item__name font-size-18 font-sanpro-semibold primary-color-txt">
                                <router-link :to="{ name: 'ebook-detail', params: { id: itemBook.bookId, slug: itemBook.slug } }" class="primary-color-txt">
                                  {{ itemBook.name }}
                                </router-link>
                              </h3>
                              <p class="margin-0 secondary-color-txt font-size-14">Năm xuất bản: {{ itemBook.editionYear }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
              </div>
          </b-tab>
        </b-tabs>
    

        
      </div>
    </div>
  </section>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex';
  import {STORE_KEY} from '../_store/constants'
  import store from '../_store'
  import EBookFilter from './EBookFilter'

  import { APP_CONFIG } from '@/utils/constants'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  const imgNext = require('@/assets/images/next.png')
  const imgPrev = require('@/assets/images/prev.png')
  const imgBookType1 = require('@/assets/images/book/book_type_1.png')
  const imgBookType2 = require('@/assets/images/book/book_type_2.png')
  const imgBanner = require('@/assets/images/book/banner_sdt.jpg')

export default {
  name: 'BookGroup',
  components: {
    EBookFilter,
   swiper, 
   swiperSlide
  },
  data() {
    return {
      id: this.$route.params.id,
      filterType: 0,
      // filterObj:{
      //   book_type: [],
      //   classes: [],
      //   levels: [],
      //   subjects : []
      // }
      imgNext,
      imgPrev,
      imgBookType1,
      imgBookType2,
      imgBanner,
      cdnUrl: APP_CONFIG.cdnUrl,
      selectType: 0,
      selectClass: 1
      }
  },
  computed: {
    ...mapGetters({
      ebooks: STORE_KEY + '/ebooks',
      //filterObj: STORE_KEY + '/ebooksFilter',
      //filters: STORE_KEY + '/filters'
    })
  },
  mounted() {

   var params={
     book_type: [],
     classes: [],
     levels : [],
     subjects : []
   }
   params.book_type.push(this.id);
    this.$store.dispatch(STORE_KEY + '/getEBooks',params);
    //this.$store.dispatch(STORE_KEY + '/getFilters');
  },
  methods:{
    thumbUrl(filename) {
      return require(`@/assets${filename}`);
    },
    viewAll(type){
      this.filterType= type;
    },
    isFilter(){
      return (this.filterObj.book_type!=null &&this.filterObj.book_type.length>0)
      || (this.filterObj.classes!=null && this.filterObj.classes.length>0)
      || (this.filterObj.levels!=null && this.filterObj.levels.length>0)
      || (this.filterObj.subjects!=null && this.filterObj.subjects.length>0);
    },
    filterBooks(filterData){
      // console.log("filterBooks")
      // console.log(filterData);
      this.$store.dispatch(STORE_KEY + '/getEBooks',filterData);
    },

    filterByClass(classId){
      this.selectClass=classId;
      if(this.selectType>0&&this.selectClass>0){
        this.$store.dispatch(STORE_KEY + '/getEBooks', {book_type: [this.selectType], classes: [this.selectClass]});
      }
      else if (this.selectClass>0){
        this.$store.dispatch(STORE_KEY + '/getEBooks', {classes: [this.selectClass]}); 
      }
      else{
       this.$store.dispatch(STORE_KEY + '/getEBooks', {});  
      }

    },
    
    filterByType(id){
      this.selectType= parseInt(id);

      if(this.selectClass > 0 && this.selectType > 0){
        this.$store.dispatch(STORE_KEY + '/getEBooks', {book_type: [this.selectType], classes: [this.selectClass]});
      } else if(this.selectType > 0){
        this.$store.dispatch(STORE_KEY + '/getEBooks', {book_type: [this.selectType]}); 
      } else{
       this.$store.dispatch(STORE_KEY + '/getEBooks', {});  
      }
    }
  }
}
</script>
<style>
.swiper-container{
  padding-bottom: 50px;
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
  bottom: -24px;
    display: block;
    height: 50px;
}
@media (max-width: 768px){
  .swiper-slide{
    width: 250px;
    padding-left: 15px;
    margin-right: 20px;
  }
}
</style>